import React from "react";
import Content from './components/Content';
import MobileSubmit from './components/Tabs/MobileSubmit';

const Components = {
    save:MobileSubmit
  };

function MobileSave() {
    return <Content Components={Components} page='submit' />
}

export default React.memo(MobileSave);